import AuthService from '../services/authentication.service';

export default function authHeader() {
  const currentUser = AuthService.getCurrentUser();
  if (currentUser && currentUser.access) {
    return `Bearer ${currentUser.access}`;
  }
  return {};
}
